import * as S from './TARating.styles';
import HappyTripAdvisorIcon from '@stencil/icons/src/HappyTripAdvisorIcon/HappyTripAdvisorIcon';
import {ratingsArrayCreator} from '@stencil/hotels-utils/src/external-rating-object-creator';

export const TARating: React.FC<{
  rating?: number | undefined | null;
  hasIcon?: boolean | undefined;
  circleSize?: any;
  iconWidth?: any;
  iconHeight?: any;
}> = ({rating, hasIcon = true, circleSize = 12, iconWidth = '2.6rem', iconHeight = '2rem'}) => {
  const renderRatingsCircles = () => {
    const ratingsArray = ratingsArrayCreator(rating);
    return ratingsArray.map((item, index) => {
      let className: string;

      switch (item) {
        case 1: {
          className = '';
          break;
        }
        case 0.5: {
          className = 'half';
          break;
        }
        case 0: {
          className = 'blank';
          break;
        }
      }

      return (
        <S.TARatingListItem
          circleSize={circleSize}
          key={index}
          className={className}
        ></S.TARatingListItem>
      );
    });
  };

  return (
    <S.TARatingWrapper>
      {hasIcon && <HappyTripAdvisorIcon width={iconWidth} height={iconHeight} margin="0 4px 0 0" />}
      {renderRatingsCircles()}
    </S.TARatingWrapper>
  );
};
